import type { PartnerCaptureManifest } from './api/types';

/**
 * Applies the per-partner manifest (`GET /capture/manifest`) to the
 * `--color-*` custom properties declared in `@theme` (src/index.css), so
 * every component that reads a token (never a literal hex) repaints for
 * the signed-in tenant. Matches the whitelabel convention this platform
 * already runs for `apps/classification-ui`.
 */
export function applyManifestTheme(manifest: PartnerCaptureManifest): void {
  const root = document.documentElement;
  root.style.setProperty('--color-brand', manifest.theme.brandColor);
  if (manifest.theme.accentColor) {
    root.style.setProperty('--color-accent', manifest.theme.accentColor);
  }
  if (manifest.theme.surfaceColor) {
    root.style.setProperty('--color-surface', manifest.theme.surfaceColor);
  }
  document.title = manifest.displayName ? `${manifest.displayName} Capture` : 'AICA Smart Capture';

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', manifest.theme.brandColor);
  }
}
